function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module font/utils
 */
import ColorTableView from './ui/colortableview';
/**
 * The name of the font size plugin.
 */

export var FONT_SIZE = 'fontSize';
/**
 * The name of the font family plugin.
 */

export var FONT_FAMILY = 'fontFamily';
/**
 * The name of the font color plugin.
 */

export var FONT_COLOR = 'fontColor';
/**
 * The name of the font background color plugin.
 */

export var FONT_BACKGROUND_COLOR = 'fontBackgroundColor';
/**
 * Builds a proper {@link module:engine/conversion/conversion~ConverterDefinition converter definition} out of input data.
 *
 * @param {String} modelAttributeKey Key
 * @param {Array.<module:font/fontfamily~FontFamilyOption>|Array.<module:font/fontsize~FontSizeOption>} options
 * @returns {module:engine/conversion/conversion~ConverterDefinition}
 */

export function buildDefinition(modelAttributeKey, options) {
  var definition = {
    model: {
      key: modelAttributeKey,
      values: []
    },
    view: {},
    upcastAlso: {}
  };

  var _iterator = _createForOfIteratorHelper(options),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var option = _step.value;
      definition.model.values.push(option.model);
      definition.view[option.model] = option.view;

      if (option.upcastAlso) {
        definition.upcastAlso[option.model] = option.upcastAlso;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return definition;
}
/**
 * A {@link module:font/fontcolor~FontColor font color} and
 * {@link module:font/fontbackgroundcolor~FontBackgroundColor font background color} helper
 * responsible for upcasting data to the model.
 *
 * **Note**: The `styleAttr` parameter should be either `'color'` or `'background-color'`.
 *
 * @param {String} styleAttr
 * @return {String}
 */

export function renderUpcastAttribute(styleAttr) {
  return function (viewElement) {
    return normalizeColorCode(viewElement.getStyle(styleAttr));
  };
}
/**
 * A {@link module:font/fontcolor~FontColor font color} and
 * {@link module:font/fontbackgroundcolor~FontBackgroundColor font background color} helper
 * responsible for downcasting a color attribute to a `<span>` element.
 *
 * **Note**: The `styleAttr` parameter should be either `'color'` or `'background-color'`.
 *
 * @param {String} styleAttr
 */

export function renderDowncastElement(styleAttr) {
  return function (modelAttributeValue, viewWriter) {
    return viewWriter.createAttributeElement('span', {
      style: "".concat(styleAttr, ":").concat(modelAttributeValue)
    }, {
      priority: 7
    });
  };
}
/**
 * A helper that adds {@link module:font/ui/colortableview~ColorTableView} to the color dropdown with proper initial values.
 *
 * @param {Object} config The configuration object.
 * @param {module:ui/dropdown/dropdownview~DropdownView} config.dropdownView The dropdown view to which
 * a {@link module:font/ui/colortableview~ColorTableView} will be added.
 * @param {Array.<module:ui/colorgrid/colorgrid~ColorDefinition>} config.colors An array with definitions
 * representing colors to be displayed in the color table.
 * @param {String} config.removeButtonLabel The label for the button responsible for removing the color.
 * @param {String} config.documentColorsLabel The label for the section with document colors.
 * @param {String} config.documentColorsCount The number of document colors inside the dropdown.
 * @returns {module:font/ui/colortableview~ColorTableView} The new color table view.
 */

export function addColorTableToDropdown(_ref) {
  var dropdownView = _ref.dropdownView,
      colors = _ref.colors,
      columns = _ref.columns,
      removeButtonLabel = _ref.removeButtonLabel,
      documentColorsLabel = _ref.documentColorsLabel,
      documentColorsCount = _ref.documentColorsCount;
  var locale = dropdownView.locale;
  var colorTableView = new ColorTableView(locale, {
    colors: colors,
    columns: columns,
    removeButtonLabel: removeButtonLabel,
    documentColorsLabel: documentColorsLabel,
    documentColorsCount: documentColorsCount
  });
  dropdownView.colorTableView = colorTableView;
  dropdownView.panelView.children.add(colorTableView);
  colorTableView.delegate('execute').to(dropdownView, 'execute');
  return colorTableView;
} // Fixes the color value string.
//
// @param {String} value
// @returns {String}

function normalizeColorCode(value) {
  return value.replace(/\s/g, '');
}